import { useNavigate } from 'react-router-dom';

import { Button } from '@dmp/components/ui/Button/Button';
import { ROUTE_PATHS } from '@dmp/constant';

export const NonLoggedInActions = () => {
  const navigate = useNavigate();

  if (window.location.pathname === ROUTE_PATHS.MASTER) return null;

  return (
    <div className="w-full md:w-auto flex items-center justify-center gap-[10px] order-3">
      <Button
        variant="primary"
        onClick={() => {
          navigate(ROUTE_PATHS.LOGIN);
        }}
      >
        Log In
      </Button>
      <Button onClick={() => navigate(ROUTE_PATHS.REGISTER)} className="hover:bg-[#5929D0]! hover:text-white!">
        Register
      </Button>
    </div>
  );
};
